"use client";

// Renders the form of a form-builder widget (docs: documents/hooks/useWidgetFormRenderer.md). The code lives in ../form-renderer.
export { default } from "@core/helpers/client/form-renderer/use_widget_form";
